import React, { useState } from 'react';
import NavbarAdmin from '../components/NavbarAdmin';
import SidebarMenu from '../components/SidebarMenu';


const LayoutAdmin = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="h-screen flex overflow-hidden bg-[oklch(97%_0.014_254.604)]">
      {/* Sidebar en modo móvil (drawer) */}
      <SidebarMenu isOpen={sidebarOpen} toggleDrawer={() => setSidebarOpen(false)} />

      {/* Layout principal con sidebar fijo en pantallas grandes */}
      <div className="flex flex-col flex-1 w-0">
        <NavbarAdmin toggleDrawer={() => setSidebarOpen(true)} />

        {/* Contenido principal */}
        <main className="flex-1 overflow-y-auto focus:outline-none p-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default LayoutAdmin;
